import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import './style.css';

// Mesmos rotulos da tela de usuarios (UpdateUser).
export const NIVEIS_ACESSO = [
  { level: 8, label: 'Superadmin' },
  { level: 5, label: 'ADM' },
  { level: 9, label: 'Escritório' },
  { level: 1, label: 'Nível 1' },
  { level: 2, label: 'Nível 2' },
  { level: 3, label: 'Nível 3' },
  { level: 4, label: 'Nível 4' },
  { level: 6, label: 'Nível 6' },
  { level: 7, label: 'Nível 7' },
  { level: 0, label: 'Sem nível' },
];

export function describeNiveis(niveis) {
  if (!Array.isArray(niveis) || niveis.length === 0) return 'Todos os níveis';
  return NIVEIS_ACESSO
    .filter((item) => niveis.map(Number).includes(item.level))
    .map((item) => item.label)
    .join(', ');
}

const EMPTY_FORM = { id: null, name: '', ordem: '', todos: true, niveis: [] };

function MotivosPerdaConfig({ onClose }) {
  const [motivos, setMotivos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState(null);

  const errorMessage = (err, fallback) => err?.response?.data?.message || fallback;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/motivos-perda/admin');
      setMotivos(Array.isArray(response.data) ? response.data : []);
      setError('');
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível carregar os motivos de perda.'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew = () => setForm({ ...EMPTY_FORM });
  const openEdit = (item) => setForm({
    id: item.id,
    name: item.name,
    ordem: String(item.ordem ?? ''),
    todos: !item.niveis_visiveis?.length,
    niveis: (item.niveis_visiveis || []).map(Number),
  });

  const toggleNivel = (level) => setForm((current) => ({
    ...current,
    niveis: current.niveis.includes(level)
      ? current.niveis.filter((item) => item !== level)
      : [...current.niveis, level],
  }));

  const save = async () => {
    if (!form.name.trim()) {
      setError('Informe o nome do motivo.');
      return;
    }
    if (!form.todos && form.niveis.length === 0) {
      setError('Selecione ao menos um nível ou marque "Todos os níveis".');
      return;
    }
    const payload = {
      name: form.name.trim(),
      niveis_visiveis: form.todos ? [] : form.niveis,
      ...(String(form.ordem).trim() !== '' ? { ordem: Number(form.ordem) } : {}),
    };
    setSaving(true);
    try {
      if (form.id) await api.put(`/motivos-perda/${form.id}`, payload);
      else await api.post('/motivos-perda', payload);
      setForm(null);
      await load();
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível salvar o motivo.'));
    } finally {
      setSaving(false);
    }
  };

  const setAtivo = async (item, ativo) => {
    if (!ativo && !window.confirm(`Desativar "${item.name}"? Ele deixa de aparecer para novas perdas, mas os cards antigos mantêm o motivo.`)) return;
    setSaving(true);
    try {
      if (ativo) await api.put(`/motivos-perda/${item.id}`, { ativo: true });
      else await api.delete(`/motivos-perda/${item.id}`);
      await load();
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível alterar o motivo.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="parameter-modal">
      <div className="parameter-container motivos-perda-config">
        <div className="parameter-header">
          <label className="parameter-title">Motivos de Perda</label>
        </div>
        <div className="parameter-body">
          <p className="motivos-perda-hint">
            Cada motivo aparece só para os níveis marcados. Desativar não apaga: os cards antigos mantêm o motivo registrado.
          </p>
          {error && <div className="motivos-perda-error">{error}</div>}

          {form && (
            <div className="motivos-perda-form">
              <label>
                Nome do motivo
                <input value={form.name} maxLength={120} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ex.: SDR - Tentativas esgotadas" />
              </label>
              <label>
                Ordem
                <input type="number" value={form.ordem} onChange={(e) => setForm({ ...form, ordem: e.target.value })} placeholder="Automática" />
              </label>
              <div className="motivos-perda-niveis">
                <span>Quem vê este motivo</span>
                <label className="motivos-perda-check">
                  <input type="checkbox" checked={form.todos} onChange={(e) => setForm({ ...form, todos: e.target.checked })} />
                  Todos os níveis
                </label>
                {!form.todos && NIVEIS_ACESSO.map((item) => (
                  <label className="motivos-perda-check" key={item.level}>
                    <input type="checkbox" checked={form.niveis.includes(item.level)} onChange={() => toggleNivel(item.level)} />
                    {item.label}
                  </label>
                ))}
              </div>
              <div className="motivos-perda-form-actions">
                <button className="btn-close-parameter" onClick={() => { setForm(null); setError(''); }} disabled={saving}>Cancelar</button>
                <button className="btn-add-parameter" onClick={save} disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </div>
          )}

          {loading && <p className="motivos-perda-hint">Carregando...</p>}
          {!loading && motivos.map((item) => (
            <div className={`item-list-parameter ${item.ativo ? '' : 'motivos-perda-inativo'}`} key={item.id}>
              <div className="motivos-perda-item">
                <label className="label-item-parameter">{item.name}</label>
                <small>
                  Ordem {item.ordem} · {describeNiveis(item.niveis_visiveis)}{item.ativo ? '' : ' · Inativo'}
                </small>
              </div>
              <div className="btns-item-list">
                {item.ativo
                  ? <button className="btn-remove-item-list" onClick={() => setAtivo(item, false)} disabled={saving}>Desativar</button>
                  : <button className="btn-edite-item-list" onClick={() => setAtivo(item, true)} disabled={saving}>Reativar</button>}
                <button className="btn-edite-item-list" onClick={() => openEdit(item)} disabled={saving}>Editar</button>
              </div>
            </div>
          ))}
        </div>
        <div className="parameter-footer">
          <button className="btn-close-parameter" onClick={onClose}>Fechar</button>
          <button className="btn-add-parameter" onClick={openNew} disabled={saving || Boolean(form)}>Adicionar</button>
        </div>
      </div>
    </div>
  );
}

export default MotivosPerdaConfig;
